import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import { DateRangeOutlined } from '@material-ui/icons'
import { FC, memo } from 'react'

import { InterestLayers, layersMap } from '@/constants/diagnoses'
import { UseGetPhysiologicalDiagnosisByIdResponse } from '@/hooks/queries/use-get-physiological-diagnosis-by-id'

import { useStyles } from './styles'

type ResultsProps = {
  unitOfMeasurement?: string
  diagnosis: UseGetPhysiologicalDiagnosisByIdResponse
  selectedLayer: InterestLayers
  minInfo?: boolean
  hasTitle?: boolean
  borderColor: Record<string, string>
}

const Results: FC<ResultsProps> = ({
  diagnosis,
  selectedLayer,
  minInfo,
  hasTitle,
  borderColor,
}) => {
  const classes = useStyles()

  const renderDate = (date: string) => {
    const parsedDate = new Date(date)

    if (isNaN(parsedDate.getTime())) {
      return date
    }

    return parsedDate.toLocaleDateString('pt-BR', {
      timeZone: 'UTC',
    })
  }
  const fields =
    diagnosis?.summary?.fields?.map((field) => ({
      name: field.name,
      layers: field.layers,
    })) ?? []

  return (
    <>
      {hasTitle && (
        <Typography variant='subtitle1' className={classes.selectedLayer}>
          Diagnóstico: {layersMap[selectedLayer].message}
        </Typography>
      )}

      {minInfo && (
        <Box display='flex' alignItems='center' className={classes.minInfo}>
          <DateRangeOutlined />
          <span>
            {diagnosis ? renderDate(diagnosis.mosaic.date) : 'DD/MM/AAAA'}
          </span>
          <span>-</span>
          <span>{diagnosis ? diagnosis.phenological_stage : 'EF'}</span>
        </Box>
      )}

      <div className={classes.comparativeResults}>
        <Typography variant='h3'>Resultados comparativos</Typography>

        <Table size='small' padding='none'>
          <TableHead className={classes.tHead}>
            <TableRow>
              <TableCell></TableCell>
              {fields?.map((field, index) => (
                <TableCell key={index} align='center'>
                  <Typography>{field.name}</Typography>
                </TableCell>
              ))}{' '}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tBody}>
            <TableRow>
              <TableCell>
                <Typography variant='subtitle1'>Média</Typography>
              </TableCell>
              {fields?.map((field, index) => (
                <TableCell
                  key={index}
                  align='center'
                  style={{ backgroundColor: borderColor[field.name] }}
                >
                  <Typography variant='subtitle1'>
                    {field.layers[selectedLayer]?.mean.toFixed(2)}
                    {layersMap[selectedLayer].measurement}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant='subtitle1'>Desvio padrão</Typography>
              </TableCell>
              {fields?.map((field, index) => (
                <TableCell
                  key={index}
                  align='center'
                  style={{ backgroundColor: borderColor[field.name] }}
                >
                  <Typography variant='subtitle1'>
                    {field.layers[selectedLayer]?.std.toFixed(2)}
                    {layersMap[selectedLayer].measurement}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </>
  )
}

export default memo(Results)
